import {createFileRoute, Outlet, useLocation} from '@tanstack/react-router';
import {PATIENT_LIST} from '@/practitioner/routing/paths';

import PatientList from '@/practitioner/views/patient/PatientList';

function PatientLayout() {
  const {pathname} = useLocation();
  const isRoot = pathname === PATIENT_LIST;
  return isRoot ? <PatientList /> : <Outlet />;
}

export const Route = createFileRoute('/(practitioner)/patients')({
  component: PatientLayout
});
